module.exports = __webpack_public_path__ + "img/a49e4fe.jpg";